module.exports = require("highcharts-grouped-categories");
